import React, { useEffect, useState } from "react";
import "./professionalsummary.css";
import PopupForm from "Components/ReusableComponents/PopupForm";
import ReactDOM from "react-dom";
import { Card, message, Tooltip } from "antd";
import useCustomizeDash from "hooks/useCustomizeDash";
import HELPERS from "utils/helper";
import DASHBOARD_API from "api/dashboard";
import { selectProfessionalSummary, selectStepReflections, setProfessionalSummaryAsync } from "slices/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const ProfessionalSumary = ({setLeftSections, setRightSections, compID, left, tmpState, setTmpState}) => {
  const [toggling, setToggling] = useState(false);
  const { isDropdownOpen } = useCustomizeDash();
  const userId = HELPERS.getUserId();
  const dispatch = useDispatch();
  const history = useHistory();
  const stepReflections = useSelector(selectStepReflections);
  const professionalSummary = useSelector(selectProfessionalSummary);
  const [stepStatusLockChech, setStepStatusLockChech] = useState(false);
    
  console.log('sss updateProfessionalSummary', professionalSummary, !professionalSummary.Api_response[0]?.[0])

  const isLocked = (step) =>
    stepReflections[step] ? stepReflections[step].status === "LO" : false;

  const handleSave = (data, id) => {
    // console.log("sss Saved Data:", data, id);
    // return
    const payload = {
      professional_summary: data,
    };
    message.success("Your work has been saved")
    dispatch(setProfessionalSummaryAsync(payload, id, "PS"))
    // .then(() => {
    //   message.success("Your work has been saved")
    // })
    // .catch((err) => {
    //   message.error("Your work has not been saved")
    // });
  };

  useEffect(() => {
    setStepStatusLockChech(isLocked('PS'))
  }, [stepReflections])

  const handleEdit = () => {
    if (stepStatusLockChech) {
      // Could show a different modal, toast, or just prevent navigation
      message.error('This is locked')
    } else {
      history.push("/personal-branding/professional-summary");
      window.scrollTo(0, 0);
    }
  }


  const handleDelete = () => {
    // left ? setLeftSections((prev) => prev.filter((section) => section.id !== compID)) : setRightSections((prev) => prev.filter((section) => section.id !== compID));
    try {
      const payload = { "step_id": compID, "user_id": userId }
      console.log("sss delete", payload);
      DASHBOARD_API.deleteDashboardItem(payload)
      .then((response) => {
        console.log("sss delete api response", response);
        message.success("Your work has been saved")
        setTmpState(!tmpState)
      })
      .catch((err) => {
        console.log("sss delete api error", err, payload);
        message.error("Your work has not been saved")
      });
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  
  const flattenWithAndBeforeLastGroup = (obj) => {
    const keys = Object.keys(obj);
    const lastKey = keys[keys.length - 1];
  
    const result = keys.flatMap((key, i) => {
      const group = obj[key];
      // Add 'and ' only before the last group
      return key === lastKey ? ['and ' + group.join(', ')] : group;
    });
  
    return result.join(', ');
  };
  
  const convertToArray = (obj, exArr) => {
    const newObj = {};

    Object.keys(obj).forEach((key) => {
      newObj[key] = typeof obj[key] === 'string' ? obj[key].split('\n').filter(Boolean) : obj[key];
    });


    if (Array.isArray(exArr) && exArr.length > 0) {
      const newIndex = Object.keys(newObj).length;
      newObj[newIndex] = exArr;
      exArr.forEach((value, key) => {
        // console.log('sss convertToArray key', newObj, value, key)
        newObj[newIndex+key] = [value];
      })
    }

    const result = flattenWithAndBeforeLastGroup(newObj);
    // console.log('sss convertToArray obj', newObj, result, exArr)
    return result;
  }

  const tooltipContent = () => (
    <>
      <p style={{ fontSize: "15px", lineHeight: "21px", marginBottom: "0px", }}>Please fill out your professional summary <a href="javascript:void(0)" rel="noopener noreferrer" onClick={handleEdit}>here</a>.</p>
    </>
  )

  

  return (
    <>
      <Card
        bordered={false}
        style={{
          boxShadow: "0px 3px 16px 0px #1313131A",
          borderRadius: "12px",
          textAlign: "left",
          margin: "0px 20px",
          height: "fit-content",
        }}
      >
        <div className="h" style={{ fontWeight: "bold", textAlign: "left" }}>
          <div className="stg-header">
            <div className="stg-left-header">
              <img
                src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg"
                className="stg-icon"
                alt="drag icon"
              />
              <span className="professional-summary-title">
                My Professional Summary
              </span>
            </div>
            {
              isDropdownOpen ? (
                <img
                  src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
                  alt="delete icon"
                  className="delete-icon"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={handleDelete}
                />
              ) : (
                <Tooltip
                  overlay={tooltipContent}
                  trigger="hover"
                  placement="bottom"
                  overlayClassName={[
                    "prof-summ-content-tooltip",
                    (professionalSummary.Api_response.edited ? "ant-tooltip-hidden" : "")
                  ].join(" ")}
                >
                  <img
                    role="button"
                    className="edit-icon"
                    style={{cursor: "pointer"}}
                    src="https://django-woken-static.s3.amazonaws.com/static/media/editbtn.svg"
                    alt="edit-icon"
                    onClick={() => { 
                      if(professionalSummary.Api_response.edited){
                        setToggling(true);
                      }
                    }}
                  />
                </Tooltip>
              )
            }
            {toggling &&
              ReactDOM.createPortal(
                <PopupForm
                  formData={professionalSummary.Api_response}
                  onSave={handleSave}
                  onCancel={() => setToggling(!toggling)}
                />,
                document.body
              )}
          </div>
        </div>

        <div className="professional-summary">
          {
            professionalSummary.Api_response.edited && !professionalSummary.Api_response.generate ? (
              <>
                <div>
                  <p className="summary-list-title">My Background</p>
                  <ul className="summary-list">
                  {/* {
                    professionalSummary.Api_response.background.split('\n').filter(Boolean).map((line, index) => {
                      return (
                        <li key={`background-${index}`}><span className="inline-text">{line}</span></li>
                      )
                    })
                  } */}
                    {professionalSummary.Api_response.background ? (<li><span className="inline-text">{professionalSummary.Api_response.background}</span></li>) : (
                      <li>
                        <span className="inline-text placeholder">
                            I’m a [...] with expertise in [list 3-5 areas of functional skills].
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
                <div>
                  <p className="summary-list-title">My Strengths</p>
                  <ul className="summary-list">
                  {/* {
                    professionalSummary.Api_response.strength.split('\n').filter(Boolean).map((line, index) => {
                      return (
                        <li key={`strength-${index}`}><span className="inline-text">{line}</span></li>
                      )
                    })
                  } */}
                    {professionalSummary.Api_response.strength ? (<li><span className="inline-text">{professionalSummary.Api_response.strength}</span></li>) : (
                      <li>
                        <span className="inline-text placeholder">
                          What are you best at? What should someone hire you to do?
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
                <div>
                  <p className="summary-list-title">My Direction</p>
                  <ul className="summary-list">
                  {/* {
                    professionalSummary.Api_response.direction.split('\n').filter(Boolean).map((line, index) => {
                      return (
                        <li key={`direction-${index}`}><span className="inline-text">{line}</span></li>
                      )
                    })
                  } */}
                    {professionalSummary.Api_response.direction ? (<li><span className="inline-text">{professionalSummary.Api_response.direction}</span></li>) : (
                      <li>
                        <span className="inline-text placeholder">
                          I’m motivated by [list 2-3 role titles] and [2-3 industries]
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
              </>
            ) : (
              <>
                <div>
                  <p className="summary-list-title">My Background</p>
                  {
                      <ul className="summary-list">
                        {
                          (professionalSummary.Api_response.generate && (professionalSummary.Api_response[1]?.[0] || professionalSummary.Api_response[2]?.[0] || professionalSummary.Api_response[3]?.[0])) ? (
                            <li>
                              <span className="inline-text">
                              {
                                professionalSummary.Api_response.generate ? (
                                  (professionalSummary.Api_response[1]?.[0] || "") +
                                  " professional with experience in " +
                                  (professionalSummary.Api_response[2]?.[0] ? (
                                    convertToArray(professionalSummary.Api_response[2], professionalSummary.Api_response["2_added"])
                                  ) : "") +
                                  " across " +
                                  (professionalSummary.Api_response[3]?.[0] ? (
                                    convertToArray(professionalSummary.Api_response[3], professionalSummary.Api_response["3_added"])
                                  ) : "")  +
                                  " industries."
                                ) : (
                                  (professionalSummary.Api_response[1]?.[0] || "") +
                                  " " +
                                  (professionalSummary.Api_response[2]?.[0] ? (
                                    convertToArray(professionalSummary.Api_response[2], professionalSummary.Api_response["2_added"])
                                  ) : "") +
                                  " " +
                                  (professionalSummary.Api_response[3]?.[0] ? (
                                    convertToArray(professionalSummary.Api_response[3], professionalSummary.Api_response["3_added"])
                                  ) : "") 
                                )
                              }
                              </span>
                            </li>
                          ) : (
                            <li>
                              <span className="inline-text placeholder">
                                  I’m a [...] with expertise in [list 3-5 areas of functional skills].
                              </span>
                            </li>
                          )
                        }
                      </ul>
                  }
                </div>
                <div>
                  <p className="summary-list-title">My Strengths</p>
                  {
                      <ul className="summary-list">
                        {
                          (professionalSummary.Api_response.generate && (professionalSummary.Api_response[4]?.[0] || professionalSummary.Api_response[5]?.[0] || professionalSummary.Api_response[6]?.[0])) ? (
                            <li>
                              <span className="inline-text">
                              {
                                professionalSummary.Api_response.generate ? (
                                  "Strengths in " +
                                  (professionalSummary.Api_response[4]?.[0] || "") +
                                  " in order to " +
                                  (professionalSummary.Api_response[5]?.[0] || "") +
                                  " by utilizing " +
                                  (professionalSummary.Api_response[6]?.[0] ? (
                                    convertToArray(professionalSummary.Api_response[6], professionalSummary.Api_response["6_added"])
                                  ) : "") 
                                ) : (
                                  (professionalSummary.Api_response[4]?.[0] || "") +
                                  " " +
                                  (professionalSummary.Api_response[5]?.[0] || "") +
                                  " " +
                                  (professionalSummary.Api_response[6]?.[0] ? (
                                    convertToArray(professionalSummary.Api_response[6], professionalSummary.Api_response["6_added"])
                                  ) : "") 
                                )
                              }
                              </span>
                            </li>
                        ) : (
                          <li>
                            <span className="inline-text placeholder">
                              What are you best at? What should someone hire you to do?
                            </span>
                          </li>
                        )
                        }
                      </ul>
                  }
                </div>
                <div>
                  <p className="summary-list-title">My Direction</p>
                  {
                      <ul className="summary-list">
                        {
                          (professionalSummary.Api_response.generate && (professionalSummary.Api_response[4]?.[0] || professionalSummary.Api_response[5]?.[0] || professionalSummary.Api_response[6]?.[0])) ? (
                            <li>
                              <span className="inline-text">
                              {
                                professionalSummary.Api_response.generate ? (
                                  "Motivated by " +
                                  (professionalSummary.Api_response[7]?.[0] || "") +
                                  " opportunities in the " +
                                  (professionalSummary.Api_response[8]?.[0] ? (
                                    convertToArray(professionalSummary.Api_response[8], professionalSummary.Api_response["8_added"])
                                  ) : "")  +
                                  " industry."
                                ) : (
                                  (professionalSummary.Api_response[7]?.[0] || "") +
                                  " " +
                                  (professionalSummary.Api_response[8]?.[0] ? (
                                    convertToArray(professionalSummary.Api_response[8], professionalSummary.Api_response["8_added"])
                                  ) : "") 
                                )
                              }
                              </span>
                            </li>
                          ) : (
                            <li>
                              <span className="inline-text placeholder">
                                I’m motivated by [list 2-3 role titles] and [2-3 industries]
                              </span>
                            </li>
                          ) 
                        }
                      </ul>
                  }
                </div>
              </>
            )
          }
        </div>
        
      </Card>
    </>
  );
};

export default ProfessionalSumary;
